const notificationBaseUrl = (import.meta.env.VITE_TASK_NOTIFICATION_SERVICE_URL || '').trim().replace(/\/$/, '');

const postJson = async (path: string, body: unknown) => {
  if (!notificationBaseUrl) {
    console.warn('Task notification service URL not configured');
    return { skipped: true, reason: 'not-configured' };
  }

  const response = await fetch(`${notificationBaseUrl}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Bildirim servisi hatası');
  }

  return response.json().catch(() => ({ success: true }));
};

const normalizePhone = (value?: string) => String(value || '').replace(/\D/g, '');

export const taskNotificationService = {
  isConfigured() {
    return Boolean(notificationBaseUrl);
  },

  async notifyOfferCollection(data: {
    loadingCustomer: string;
    loadingCity: string;
    deliveryCity: string;
    tonnage?: number;
  }) {
    return postJson('/webhook/workiom/teklif-topla', {
      'YÜKLEME MÜŞTERİSİ': data.loadingCustomer,
      'YÜKLEME İLİ': data.loadingCity,
      'BOŞALTMA İLİ': data.deliveryCity,
      TONAJ: data.tonnage != null ? String(data.tonnage) : '',
    });
  },

  async notifyAssignment(data: {
    phoneNumber?: string;
    shipmentNo: string;
    loadingCustomer?: string;
    loadingCity?: string;
    deliveryCustomer?: string;
    deliveryCity?: string;
    vehicleType?: string;
    weightKg?: number;
    distanceKm?: number;
    agreedPrice?: number;
    loadingDate?: string;
  }) {
    const phoneNumber = normalizePhone(data.phoneNumber);
    if (!phoneNumber) {
      console.warn('Assignment notification skipped: phone number missing');
      return { skipped: true, reason: 'missing-phone' };
    }

    const lines = [
      'SİPARİŞ BİLGİLENDİRME',
      `Sevk No: ${data.shipmentNo}`,
      `Yükleme: ${data.loadingCustomer || '-'} / ${data.loadingCity || '-'}`,
      `Teslim: ${data.deliveryCustomer || '-'} / ${data.deliveryCity || '-'}`,
      `Araç Tipi: ${data.vehicleType || '-'}`,
      `Tonaj: ${Number(data.weightKg || 0).toLocaleString('tr-TR')} kg`,
      `Mesafe: ${Number(data.distanceKm || 0).toLocaleString('tr-TR')} km`,
      data.agreedPrice != null ? `Anlaşılan Tutar: ${Number(data.agreedPrice).toLocaleString('tr-TR')} ₺` : '',
      data.loadingDate ? `Yükleme Tarihi: ${new Date(data.loadingDate).toLocaleString('tr-TR')}` : '',
    ].filter(Boolean);

    return postJson('/api/whatsapp-web/webhook/send-message', {
      phoneNumber,
      message: lines.join('\n'),
    });
  },
};
